export class TncModel {
	id?: number;
	created_at?: string;
	updated_at?: string;
	name: string;
	contract: string;
	contract_code: string;
}
